import React from "react";
import { useNavigate } from "react-router-dom";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

const ItsYou = () => {
  const navigate = useNavigate();
  const { brandData } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName;
  return (
    <div className="">
      {/* It's You Section */}
      <div className="wrapper2">
        <h2 className="heading2">It's You!</h2>
      </div>

      <section className="py-0">
        <div className="container p-3">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img
                    src="img/you-bg-min.png"
                    alt=""
                    className="card-img-top"
                  />
                  <div className="position-absolute text-overlay text-white p-3">
                    <h1
                      className="fw-bold opacity-50"
                      style={{ fontSize: "4rem" }}
                    >
                      06
                    </h1>
                  </div>
                </div>
              </div>

              <p
                className="card-text text-muted py-1 px-1"
                style={{ marginLeft: "20px", fontSize: "12px" }}
              >
                Now you know where your dairy comes from – fresh farms, caring
                hands, and a promise of purity. Every sip, every bite connects
                you to the farmers, the cows, and the journey that makes your
                product special. Because in the end, it’s all about you – your
                trust, your health, and your love for quality dairy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Your Dairy, Your Story Section */}
      <div className="bg-light">
        <div className="container p-3">
          <h5 className="card-title fw-bold my-2">Your Dairy, Your Story:</h5>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-1 g-3">
            <div className="product-item col">
              <div
                className="card h-100 rounded-4 overflow-hidden osahan-card-list"
                style={{ border: "0px" }}
              >
                <style>{`
                    ul.custom-bullets {
                      list-style: disc;
                    }
                    ul.custom-bullets li {
                      font-size: 12px;
                      color: black;
                      margin-bottom: 0.5em;
                      text-indent: 0em;
                      padding-left: 1em;
                    }
                    .form-control {
                      font-size: 0.9rem;
                      background-color: #dbdbdb;
                    }
                  `}</style>

                <ul className="custom-bullets">
                  <li>Sourced with care, made for you</li>
                  <li>Pure, fresh, and rigorously tested</li>
                  <li>A journey of trust, transparency, and taste</li>
                  <li>Sustainably produced for a better tomorrow</li>
                  <li>Quality you can see, taste, and believe in</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Signup Form */}
      {/* <div class="p-4">
        <form action="index">
          <div class="mb-4">
            <label for="exampleInputEmail1" class="form-label">
              Sign up for more exciting updates from {brandName}
            </label>
            <input
              type="email"
              class="form-control rounded-lg "
              placeholder="Email ID"
              id="exampleInputEmail1"
              fdprocessedid="cvunsd"
            />
          </div>
          <div class="col-12">
            <button type="submit" class="btn btn-danger">
              Submit
            </button>
          </div>
        </form>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/distribution"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/home"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Home
        </Link>

      </div>

      {/* Divider */}
      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Stay Connected Section */}
      {/* <style>{`
          .stay-connected {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
            padding: 20px 35px;
          }
          .text-section {
            display: flex;
            flex-direction: column;
          }
          .text-section h2 {
            font-size: 18px;
            font-weight: bold;
            margin: 0;
            color: #000;
          }
          .text-section p {
            font-size: 13px;
            color: #666;
            margin: 4px 0 0;
          }
          .icon-section {
            display: flex;
            align-items: center;
            gap: 20px;
          }
          .icon-section i {
            font-size: 20px;
            color: #4CAF50;
            cursor: pointer;
          }
        `}</style>

      <div className="stay-connected">
        <div className="text-section">
          <h2>Stay Connected!</h2>
          <p>Follow Us for the Latest Updates</p>
        </div>
        <div className="icon-section">
          <img
            src="img/share.png"
            onClick={() => alert("Share functionality goes here")}
            title="Share"
            alt="Share"
            style={{ height: "25px", cursor: "pointer" }}
          />
          <a
            href="https://wa.me/?text=Check%20this%20out!"
            target="_blank"
            rel="noreferrer"
            title="WhatsApp"
          >
            <img src="img/whatsapp.png" width="25px" alt="WhatsApp" />
          </a>
          <a
            href="mailto:?subject=Stay%20Connected&body=Check%20this%20out!"
            title="Email"
          >
            <img src="img/mail.png" width="25px" alt="Mail" />
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default ItsYou;
